import { join } from 'light-component';
import { Box } from '@common';
import { Highlighter } from '../../component';
import { service } from '../service';
import styles from '../style.module.less';
import { Base } from '../../../..';
import type { ReactElement } from 'react';
import type { ShotEyesUserProps } from './types';

export function ShotEyesUserInputMode(props: ShotEyesUserProps): ReactElement {
  return (
    <Box className={styles.inputBox} style={{ marginLeft: service.getIndent(props.path, 0.7) }}>
      <Box className={styles.subject}>
        <Highlighter title={props.title} keyword={props.keyword} className={styles.title} />
      </Box>
      <Box className={join(styles.action, styles.input)}>
        <Base.Input
          type='text'
          value={props.value}
          placeholder={props.textPlaceholder}
          readOnly={props.readonly === true}
          onChange={event => props.onPropsChange?.({ value: event.target.value })}
        />
      </Box>
    </Box>
  );
}
